import router from '@/router';
import { userlist , news ,resource ,shenhe , yjyd} from '@/axios';
import { Message } from 'element-ui'

export default {
	setUserInfo(state,data){
		console.log(data)
		state.username = data.data.username
		state.rid = data.data.rid
		state.id = data.data.id
		state.school_id = data.data.school_id
		state.token = data.token,
		state.college_id=data.data.college_id,
		state.img=data.data.img,
		state.authid=data.data.auth_id,
		state.comm_id=data.data.comm_id,
		sessionStorage.setItem("username",data.data.username);
		sessionStorage.setItem("rid",data.data.rid);
		sessionStorage.setItem("id",data.data.id);
		sessionStorage.setItem("school_id",data.data.school_id);
		sessionStorage.setItem("token",data.token);
		sessionStorage.setItem('uploadImg',config.uploadImg)
		sessionStorage.setItem('college_id',data.data.college_id)
		sessionStorage.setItem('img',data.data.img)
		sessionStorage.setItem('authid',data.data.auth_id)
		sessionStorage.setItem('caid',data.data.cate_id)
		sessionStorage.setItem('college_id',data.data.college_id)
		sessionStorage.setItem('comm_id',data.data.comm_id)
		Message({
			type:"success",
			message:"成功"
		})
		setTimeout(function(){
			// if(state.rid==2){
				router.go(-1);
			// }
			
		},800)
	},
	// 退出登录
	exit(state,data){
		sessionStorage.clear();
	},
	// 用户账号列表
	userlist(state,data){
		userlist.userlist(data).then(res => {
			state.userlist.tabledata = []
			state.userlist.tabledata = res.data.pagedata
			state.userlist.total = res.data.total;
			state.userlist.count = res.data.count;
		})
	},
	// 新闻列表
	newlist(state,data){
		news.newslist(data).then(res => {
			state.newslist.tabledata = []
			state.newslist.tabledata = res.data.pagedata
			state.newslist.total = res.data.total;
			state.newslist.count = res.data.count;
		})
	},
	// 新增新闻
	addNews(state,data){
		var that = this;
		if(state.newslist.uploaddata.moduleClass.length == 0){
			Message({
				message:"请选择模块",
				type:'warning'
			})
			return false;
		}else{
			if(state.newslist.uploaddata.moduleClass[1] != 8){
				if(state.newslist.uploaddata.title == ''){
					Message({
						message:"请输入标题",
						type:'warning'
					})
					return false;
				}else if(state.newslist.uploaddata.pubuser == ''){
					Message({
						message:"请输入发布人姓名",
						type:'warning'
					})
					return false;
				}else if(state.newslist.uploaddata.pubtime == ''){
					Message({
						message:"请选择发布时间",
						type:'warning'
					})
					return false;
				}else if(state.newslist.uploaddata.content == ''){
					Message({
						message:"请输入正文内容",
						type:'warning'
					})
					return false;
				}else{
					if(state.newslist.uploaddata.banner == 1 || state.newslist.uploaddata.moduleClass[1] == 5){
						if(state.newslist.uploaddata.sz_img == ''){
							Message({
								message:"请上传封面图",
								type:'warning'
							})
							return false;
						}
					}
				}
			}else{
				if(state.newslist.uploaddata.title == ''){
					Message({
						message:"请输入教师姓名",
						type:'warning'
					})
					return false;
				}else if(state.newslist.uploaddata.sz_img == ''){
					Message({
						message:"请上传照片",
						type:'warning'
					})
					return false;
				}else if(state.newslist.uploaddata.content == ''){
					Message({
						message:"请输入正文内容",
						type:'warning'
					})
					return false;
				}
			}
			if(state.newslist.type == 'add'){
				state.newslist.uploaddata.status = data;
				news.pubNews(state.newslist.uploaddata).then(res => {
					if(res.code == 200){
						router.go(-1);
					}
				})
			}else{
				state.newslist.uploaddata.status = data;
				news.updateNews(state.newslist.uploaddata).then(res => {
					if(res.code == 200){
						router.go(-1);
					}
				})
			}
		}
	},
	// 新增新闻成功后清除表单
	clearNewsForm(state,data){
		state.newslist.uploaddata.status = 6;
		state.newslist.disabled = false;
		state.newslist.type = 'add';
		state.newslist.imageUrl = '';
		state.newslist.upfm = '上传封面';
		for(var key in state.newslist.uploaddata){
			if(key != "uid"){
				state.newslist.uploaddata[key] = "";
			}
		}
	},
	// 编辑当前新闻
	updateNews(state,data){
		news.selectNew({id:data}).then(res => {
			if(res.code == 200){
				state.newslist.uploaddata = {
					id:res.data.id,
					title:res.data.title,
					uid:res.data.uid,
					moduleClass:[res.data.mid,res.data.mid2],
					status:res.data.status,
					banner:res.data.banner,
					sz_img:res.data.sz_img,
					content:res.data.content,
					pubtime:res.data.pubtime,
					pubuser:res.data.pubuser
				}
				if(res.data.banner == 1){
					state.newslist.imageUrl = res.data.sz_img;
					if(state.newslist.imageUrl != ''){
						state.newslist.upfm = "重新上传"
					}else{
						
					}
				}
				if(res.data.status == 5){
					state.newslist.reason = res.data.reason
				}
				state.newslist.disabled =   parseInt(res.data.status) == 1 
								|| parseInt(res.data.status) == 2
								|| parseInt(res.data.status) == 3
								|| parseInt(res.data.status) == 4?true:false
			}else{
				return false
			}
		})
	},
	// 新闻页跳转
	goNewsDetail(state,data){
		router.push({
			path:'/addNews',
			query:{
				id:data.id,
				type:data.type,
			}
		})
	},
	// 资源列表
	resource(state,data){
		resource.resourceList(data).then(res => {
			state.resourcelist.tabledata = [];
			state.resourcelist.tabledata = res.data.pagedata
			state.resourcelist.total = res.data.total;
			state.resourcelist.count = res.data.count;
		})
	},
	// 资源审核列表
	resources1(state,data){
		// console.log(data)
		resource.resourceslist(data).then(res => {
			state.resourcelist.tabledata = [];
			state.resourcelist.tabledata = res.data.pagedata
			state.resourcelist.total = res.data.total;
			state.resourcelist.count = res.data.count;
		})
	},
	// 下载资源
	downfile(state,data){
		console.log(resource.zydown)
		resource.zydown(data).then(res => {
			Message({
				type: 'success',
				message: '成功!'
			})
		})
	},
	// 新增资源
	addResource(state,data){
		// console.log(state.resourcelist.uploaddata.school_id)
		if(state.resourcelist.uploaddata.title == ""){
			Message({
				message:"请输入标题",
				type:'warning'
			})
		}else if(state.resourcelist.uploaddata.mid3 == '' && state.resourcelist.uploaddata.mid!==5){
			Message({
				message:"请选择模块",
				type:'warning'
			})
		}else if(state.resourcelist.uploaddata.keys.length == 0){
			Message({
				message:"请输入关键字",
				type:'warning'
			})
		}else if(state.resourcelist.uploaddata.sz_img == ''){
			Message({
				message:"请上传封面图",
				type:'warning'
			})
		// }else if(state.resourcelist.uploaddata.level === ''){
		// 	Message({
		// 		message:"请选择资源等级",
		// 		type:'warning'
		// 	})
		}else if(state.resourcelist.uploaddata.famous_teacher.length == ''){
			Message({
				message:"请选择教学名师",
				type:'warning'
			})
		}else if(state.resourcelist.uploaddata.team_teacher.length == ''){
			Message({
				message:"请选择教学团队",
				type:'warning'
			})
		}else if(state.resourcelist.uploaddata.content == ''){
			Message({
				message:"请输入内容简介",
				type:'warning'
			})
		}else{
			if(state.resourcelist.uploaddata.keys.length < 2){
				Message({
					message:"最少输入两个关键字",
					type:'warning'
				})
			}else{
				if(state.resourcelist.uploaddata.mid==1){
					if(state.resourcelist.uploaddata.bsid==""){
						Message({
							message:"请选择资源类型",
							type:'warning'
						})
					}
					if(state.resourcelist.uploaddata.bsid == 1){
						if(state.resourcelist.uploaddata.v_url.length == 0){
							Message.warning("请选择文件")
							return false
						}
					}else if(state.resourcelist.uploaddata.bsid == 2) {
						if(state.resourcelist.uploaddata.p_url.length == 0){
							Message.warning("请选择文件")
							return false
						}
					}else{
						if(state.resourcelist.uploaddata.h_url.length == 0){
							Message.warning("请选择文件")
							return false
						}
					}
				}else if(state.resourcelist.uploaddata.mid==2){
					if(state.resourcelist.uploaddata.v_url.length == 0 && state.resourcelist.uploaddata.p_url.length == 0){
						Message.warning("请上传案例或课件")
						return false
					}
				}else if(state.resourcelist.uploaddata.mid==3){
					if(state.resourcelist.uploaddata.h_url.length == 0){
						Message.warning("请上传教学设计")
						return false
					}
					if(state.resourcelist.uploaddata.p_url.length == 0 && state.resourcelist.uploaddata.v_url.length == 0){
						Message.warning("请上传的德育融入表或案例")
						return false
					}
					// if(state.resourcelist.uploaddata.v_url.length == 0){
					// 	Message.warning("请上传案例")
					// 	return false
					// }
				}else if(state.resourcelist.uploaddata.mid==4){
					// if(state.resourcelist.uploaddata.p_url.length == 0){
					// 	Message.warning("请上传课件")
					// 	return false
					// }
					// if(state.resourcelist.uploaddata.h_url.length == 0){
					// 	Message.warning("请上传教案")
					// 	return false
					// }
					// if(state.resourcelist.uploaddata.a_url.length == 0){
					// 	Message.warning("请上传教案")
					// 	return false
					// }
					// if(state.resourcelist.uploaddata.v_url.length == 0){
					// 	Message.warning("请上传视频")
					// 	return false
					// }
				}else if(state.resourcelist.uploaddata.mid==5){
					if(state.resourcelist.uploaddata.v_url.length == 0){
						Message.warning("请上传微课")
						return false
					}
				}
				if(state.resourcelist.type1 == 'add'){
					state.resourcelist.uploaddata.status = data.status
					// state.resourcelist.uploaddata.mid3=data.data.mid3.join(',')
					state.resourcelist.uploaddata.team_teacherr=data.data.team_teacher.join(',')
					state.resourcelist.uploaddata.famous_teacher=data.data.famous_teacher.join(',')
					resource.addResouce(data.data).then(res => {
						if(res.code == 200){
							router.go(-1);
						}
					})
				}else{
					state.resourcelist.uploaddata.status = data.status
					// state.resourcelist.uploaddata.mid3=data.data.mid3.join(',')
					state.resourcelist.uploaddata.team_teacherr=data.data.team_teacher.join(',')
					state.resourcelist.uploaddata.famous_teacher=data.data.famous_teacher.join(',')
					resource.updateResource(data.data).then(res => {
						if(res.code == 200){
							router.go(-1);
						}
					})
				}
			}
		}
	},
	// 编辑资源
	updateResource(state,data){
		resource.updateResource(data).then(res => {
			if(res.code == 200){
				for(var key in state.resourcelist.uploaddata){
					if(key != "uid" && key != "status"){
						state.resourcelist.uploaddata[key] = "" ;
						state.resourcelist.uploaddata[key] = [];
					}
				}
				router.go(-1)
			}
		})
	},
	// 新增资源成功后清除表单
	clearResourceForm(state,data){
		state.resourcelist.type = 'add'
		state.resourcelist.disabled = false;
		state.resourcelist.imageUrl = ''
		state.resourcelist.upfm = '上传封面'
		for(var key in state.resourcelist.uploaddata){
			if(key != "uid" && key != "status"){
				if(key == "moduleClass" || key == "keys" || key == "v_url"){
					state.resourcelist.uploaddata[key] = [];
				}else if(key == "isdown"){
					state.resourcelist.uploaddata[key] = '1';
				}else if(key == "mid"){
					if(data.num==1){
						state.resourcelist.uploaddata[key] = '4';
					}else{
						state.resourcelist.uploaddata[key] = '6';
					}
				}else{
					state.resourcelist.uploaddata[key] = [];
				}
			}
		}
	},
	// 编辑当前资源
	showResource(state,data){
		
		resource.selectResouce({id:data.id,token:state.token}).then(res => {
			// let moduleClass = [];
			// console.log(res.data.moduleClass);
			// if(res.data.mid){
			// 	// moduleClass = [parseInt(res.data.mid)]
			// }
			// if(res.data.mid2){
			// 	moduleClass = [res.data.mid2]
			// }
			// if(res.data.mid3){
			// 	moduleClass = [,res.data.mid2,res.data.mid3]
			// }
			if(res.code == 200){
				var m=res.data.mid3.split(',')
				state.resourcelist.uploaddata = {
					id:res.data.id,
					title:res.data.title,
					bsid:res.data.bsid,
					uid:res.data.uid,
					isdown:res.data.isdown,
					mid:parseInt(res.data.mid),
					mid2:1,
					mid3:res.data.mid3,
					famous_teacher:res.data.famous_teacher.split(','),
					team_teacher:res.data.team_teacher.split(','),
					keys:res.data.keys,
					v_url:res.data.v_url,
					p_url:res.data.p_url,
					h_url:res.data.h_url,
					a_url:res.data.a_url,
					confirm:res.data.confirm,
					level:parseInt(res.data.level) == 0?5:parseInt(res.data.level),
					status:res.data.status,
					sz_img:res.data.sz_img,
					teacher:res.data.teacher,
					school_id:res.data.school_id,
					college_id:res.data.college_id,
					company:res.data.company,
					content:res.data.content,
					range:parseInt(res.data.range)
				}
				if(res.data.sz_img != ""){
					state.resourcelist.upfm = "重新上传"
					state.resourcelist.imageUrl = res.data.sz_img
				}
				if(res.data.status == 5){
					state.resourcelist.reason = res.data.reason
				}
				if(data.num){
					state.resourcelist.num=data.num;
				}else{
					state.resourcelist.num=''
				}
				if(data.type== 'shenhe' || data.type== 'show'){
					state.resourcelist.disabled =true;
				}else{
					state.resourcelist.disabled =false;
				}
				
			}else{
				return false
			}
		})
	},
	// 资源页跳转
	goResourceDetail(state,data){
		router.push({
			path:'/addresource',
			query:{
				id:data.id,
				type:data.type,
				num:data.num
			}
		})
	},
	//示范课
	goResourceDetails(state,data){
		router.push({
			path:'/addresource2',
			query:{
				id:data.id,
				type:data.type,
				num:data.num
			}
		})
	},
	// 内容审核列表
	examineList(state,data){
		shenhe.examineList(data).then(res =>{
			if(res.code == 200){
				state.examine.tabledata = [];
				state.examine.tabledata = res.data.pagedata;
				state.examine.count = res.data.count;
				state.examine.total = res.data.total;
			}
		})
	},
}